import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './kpi-row-scoreboard.types';
import * as constants from './kpi-row-scoreboard.constants';

export const storeKpiRowScoreboard = generateStoreResourceAction<types.IKpiRowScoreboard>(
  constants.STORE_KPI_ROW_SCOREBOARD,
);
export const clearKpiRowScoreboard = generateClearResourceAction(constants.CLEAR_KPI_ROW_SCOREBOARD);
